import { TocItem } from '@/app/shared/models';
import { getPositionTop } from '@/app/shared/utils/content-utils';
import { reportAnomaly } from '@/app/error-handling';

export const calculateSectionHeight = (sectionId: string, sections: TocItem[]): number => {
  const i = sections.findIndex((s) => s.id === sectionId);
  const position = getPositionTop(`#${sectionId}`);

  const isThereNextSection = sections.length > i + 1;
  const nextSectionId = isThereNextSection ? sections[i + 1].id : ''

  if (isThereNextSection && !nextSectionId) {
    reportAnomaly(`There is next section, but missing id of next section, i=${i}, sections.length=${sections.length}`, sections)
  }

  const nextSection = nextSectionId && $(`#${nextSectionId}`).is(':visible')
    ? sections[i + 1]
    : null;
  let nextPosition = 0;
  if (nextSection !== null) {
    nextPosition = getPositionTop(`#${nextSection.id}`);
  } else {
    const mainContentSelector = '.main-content';
    nextPosition = $(mainContentSelector).height() as number;
  }

  return nextPosition - position;
};
